import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_QUESTION,
  AddQuestionAction,
  DELETE_QUESTION,
  DeleteQuestionAction,
  GET_QUESTION,
  GET_QUESTIONS_BY_LESSON,
  GetQuestionAction,
  GetQuestionsByLessonAction,
  TOGGLE_QUESTION_STATE,
  ToggleQuestionStateAction,
  UPDATE_QUESTION,
  UPLOAD_QUESTION_DISPLAY_IMAGE,
  UPLOAD_QUESTION_IMAGE,
  UpdateQuestionAction,
  UploadQuestionDisplayImageAction,
  UploadQuestionImageAction,
} from "./actionTypes";

import {
  addQuestion,
  deleteQuestion,
  getQuestion,
  getQuestionsByLesson,
  toggleQuestionState,
  updateQuestion,
  uploadQuestionDisplayImage,
  uploadQuestionImage,
} from "../../helpers/backend_helper";
import {
  addQuestionError,
  addQuestionSuccess,
  deleteQuestionError,
  deleteQuestionSuccess,
  getQuestionError,
  getQuestionSuccess,
  getQuestionsByLessonError,
  getQuestionsByLessonSuccess,
  toggleQuestionStateError,
  toggleQuestionStateSuccess,
  updateQuestionError,
  updateQuestionSuccess,
  uploadQuestionDisplayImageError,
  uploadQuestionDisplayImageSuccess,
  uploadQuestionImageError,
  uploadQuestionImageSuccess,
} from "./actions";

function* getQuestionSaga({ payload: { id, history } }: GetQuestionAction) {
  try {
    const response: ResponseGenerator = yield call(getQuestion, id);
    yield put(getQuestionSuccess(response.data));
  } catch (error) {
    yield put(getQuestionError(error));
  }
}

function* addQuestionSaga({
  payload: { request, history },
}: AddQuestionAction) {
  try {
    yield call(addQuestion, request);
    yield put(addQuestionSuccess());
  } catch (error) {
    yield put(addQuestionError(error));
  }
}

function* updateQuestionSaga({
  payload: { id, request, history },
}: UpdateQuestionAction) {
  try {
    yield call(updateQuestion, id, request);
    yield put(updateQuestionSuccess());
  } catch (error) {
    yield put(updateQuestionError(error));
  }
}

function* deleteQuestionSaga({
  payload: { id, history },
}: DeleteQuestionAction) {
  try {
    yield call(deleteQuestion, id);
    yield put(deleteQuestionSuccess());
  } catch (error) {
    yield put(deleteQuestionError(error));
  }
}

function* getQuestionsByLessonSaga({
  payload: { lessonId, model },
}: GetQuestionsByLessonAction) {
  try {
    const response: ResponseGenerator = yield call(
      getQuestionsByLesson,
      lessonId,
      model
    );
    yield put(getQuestionsByLessonSuccess(response.data));
  } catch (error) {
    yield put(getQuestionsByLessonError(error));
  }
}

function* uploadQuestionDisplayImageSaga({
  payload: { file, history, questionId },
}: UploadQuestionDisplayImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadQuestionDisplayImage,
      file,
      questionId
    );
    yield put(uploadQuestionDisplayImageSuccess(response.data));
  } catch (error) {
    yield put(uploadQuestionDisplayImageError(error));
  }
}

function* toggleQuestionStateSaga({
  payload: { id, history },
}: ToggleQuestionStateAction) {
  try {
    yield call(toggleQuestionState, id);
    yield put(toggleQuestionStateSuccess(id));
  } catch (error) {
    yield put(toggleQuestionStateError(error));
  }
}

function* uploadQuestionImageSaga({
  payload: { file, history, tempId },
}: UploadQuestionImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadQuestionImage,
      file,
      tempId
    );
    yield put(uploadQuestionImageSuccess(response.data));
  } catch (error) {
    yield put(uploadQuestionImageError(error));
  }
}

function* QuestionSaga() {
  yield takeEvery(GET_QUESTION, getQuestionSaga);
  yield takeEvery(ADD_QUESTION, addQuestionSaga);
  yield takeEvery(UPDATE_QUESTION, updateQuestionSaga);
  yield takeEvery(DELETE_QUESTION, deleteQuestionSaga);
  yield takeEvery(GET_QUESTIONS_BY_LESSON, getQuestionsByLessonSaga);
  yield takeEvery(
    UPLOAD_QUESTION_DISPLAY_IMAGE,
    uploadQuestionDisplayImageSaga
  );
  yield takeEvery(TOGGLE_QUESTION_STATE, toggleQuestionStateSaga);
  yield takeEvery(UPLOAD_QUESTION_IMAGE, uploadQuestionImageSaga);
}

export default QuestionSaga;
